export type UseIsViewTemplateButtonVisibleProps = {
	canCreateFields: boolean;
	canManageViews: boolean;
	projectId?: string;
	projectKey?: string;
};

export const useIsViewTemplateButtonVisible = ({
	canCreateFields,
	canManageViews,
	projectId,
	projectKey,
}: UseIsViewTemplateButtonVisibleProps): boolean =>
	Boolean(canCreateFields && canManageViews && projectId && projectKey);
